import { useEffect, useRef } from "react";
import { C } from "../../shared/theme";
import { BackButton } from "../../shared/BackButton";
import { PAGE_WIDTH } from "../../shared/layout";

// A full-screen step in a short flow: ◀ back, "Help me choose · Step 2 of 3" (the page's heading) with a
// progress bar, ✕ when the flow can be left in one tap, the step itself, and the buttons along the bottom.
// Focus moves to the heading each time the step changes.
export function StepFrame({ name, step, of, onBack, backLabel, onClose, headingRef, children, footer }) {
  const ownRef = useRef(null);
  const topRef = headingRef || ownRef;
  useEffect(() => { topRef.current?.focus(); }, [step, topRef]);
  const round = { width: 44, height: 44, flexShrink: 0, borderRadius: "50%", border: "none", background: C.surface2, color: C.textMid, cursor: "pointer", fontFamily: "inherit" };
  return (
    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", background: C.bg, color: C.text }}>
      <div style={{ flexShrink: 0, maxWidth: PAGE_WIDTH, width: "100%", margin: "0 auto", padding: "12px 16px 8px", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <BackButton onClick={onBack} label={backLabel} />
          <h1 ref={topRef} tabIndex={-1} style={{ flex: 1, minWidth: 0, margin: 0, outline: "none", fontSize: 15, fontWeight: 700, color: C.textMid }}>
            <span style={{ color: C.text }}>{name}</span> · Step {step} of {of}
          </h1>
          {onClose && <button onClick={onClose} aria-label="Close" style={{ ...round, fontSize: 16 }}>✕</button>}
        </div>
        <div aria-hidden="true" style={{ display: "flex", gap: 4, marginTop: 10 }}>
          {Array.from({ length: of }, (_, n) => <span key={n} style={{ flex: 1, height: 4, borderRadius: 4, background: n < step ? C.accent : C.surface2 }} />)}
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <div style={{ maxWidth: PAGE_WIDTH, margin: "0 auto", padding: "12px 16px 24px" }}>{children}</div>
      </div>
      {footer && (
        <div style={{ flexShrink: 0, borderTop: `1px solid ${C.border}`, background: C.bg }}>
          <div style={{ maxWidth: PAGE_WIDTH, margin: "0 auto", padding: "12px 16px calc(16px + env(safe-area-inset-bottom, 0px))", display: "grid", gap: 4 }}>{footer}</div>
        </div>
      )}
    </div>
  );
}

export const stepTitle = () => ({ margin: "0 0 6px", fontSize: 22, fontWeight: 800, letterSpacing: "-0.01em", lineHeight: 1.25, color: C.text });
export const stepIntro = () => ({ margin: 0, fontSize: 15, lineHeight: 1.5, color: C.textMid });
export const primaryButton = () => ({ minHeight: 48, borderRadius: C.rsm, border: "none", background: C.accent, color: C.onAccent, fontSize: 16, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" });
export const quietButton = () => ({ minHeight: 44, border: "none", background: "none", color: C.textMid, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" });
